import { Button, Col, Form, Input, Row, Spin } from 'antd';
import '../../styles/_orgs.scss';
import useOrderToast from '../../hooks/useOrderToast';
import { CreateLocationRequest } from '../../models/OrganizationModels';
import { useCreateLocationMutation } from '../../features/organization/organizationService';

type FieldType = {
    locationName: string;
    locationId: string;
    locationCode: string;
};

const ExtraFieldLabel = ({ title }: { title: string }) => {
    return <span className="ms-3 text-semi-black-xs">{title}</span>;
};
const ValidationMessage = ({ message }: { message: string }) => {
    return <span className="ms-3">{message}</span>;
};

type Props = {
    orgId: string;
    closeModal: React.Dispatch<React.SetStateAction<boolean>>;
};

const OrganizationsNewLocationForm: React.FC<Props> = ({
    orgId,
    closeModal,
}) => {
    const [form] = Form.useForm();
    const [createLocation, { isLoading }] = useCreateLocationMutation();
    const { toast } = useOrderToast();

    const handleSubmit = async () => {
        const values: FieldType = await form.validateFields();
        try {
            const requestData: CreateLocationRequest = {
                orgId: orgId,
                locationName: values.locationName,
                locationId: values.locationId,
                locationCode: values.locationCode,
            };
            const response: any = await createLocation(requestData);
            if (response.data) {
                form.resetFields();
                closeModal(false);
                toast('The location is successfully added to the organization.', 'success', 2);
            }
            else {
                toast(
                    'The location creation is failed. Please try again.',
                    'error',
                    2,
                );
            }
        } catch (error) {
            toast(
                'The location creation is failed. Please try again.',
                'error',
                2,
            );
        }
    };
    return (
        <Spin spinning={isLoading}>
        <Form
            form={form}
            name="basic"
            layout="horizontal"
            autoComplete="off"
            className="orgs-new-team-form"
        >
            <Row>
                <Col span={24}>
                    <Form.Item<FieldType>
                        label={'Location Name'}
                        name="locationName"
                        labelCol={{ span: 4 }}
                        wrapperCol={{ span: 11 }}
                        rules={[
                            {
                                required: true,
                                message: (
                                    <ValidationMessage message="Please enter Location Name" />
                                ),
                            },
                        ]}
                        extra={
                            <ExtraFieldLabel title="Location name should align with RxLogic" />
                        }
                    >
                        <Input
                            placeholder="Enter Location Name"
                            className="ms-3 bg-light-blue-thin rounded-1"
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <Form.Item<FieldType>
                        label={'Location ID'}
                        name="locationId"
                        labelCol={{ span: 4 }}
                        wrapperCol={{ span: 11 }}
                        rules={[
                            {
                                required: true,
                                message: (
                                    <ValidationMessage message="Please enter Location ID" />
                                ),
                            },
                        ]}
                        extra={
                            <ExtraFieldLabel title="Location ID should align with RxLogic" />
                        }
                    >
                        <Input
                            placeholder="Enter Location ID"
                            className="ms-3 bg-light-blue-thin rounded-1"
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <Form.Item<FieldType>
                        label={'Location Code'}
                        name="locationCode"
                        labelCol={{ span: 4 }}
                        wrapperCol={{ span: 11 }}
                        rules={[
                            {
                                required: true,
                                message: (
                                    <ValidationMessage message="Please enter Location Code" />
                                ),
                            },
                        ]}
                        extra={
                            <ExtraFieldLabel title="Location code should align with RxLogic" />
                        }
                    >
                        <Input
                            placeholder="Enter Location Code"
                            className="ms-3 bg-light-blue-thin rounded-1"
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Row>
                <Col span={4} offset={4}>
                    <Button
                        loading={isLoading}
                        disabled={isLoading}
                        type="primary"
                        className="w-75 ms-3 bg-light-blue border-0"
                        shape="round"
                        onClick={handleSubmit}
                    >
                        Save
                    </Button>
                </Col>
            </Row>
        </Form>
        </Spin>
    );
};

export default OrganizationsNewLocationForm;
